import { type ReconcileMatchConstructor } from '@webapp/modules/accounts-payable/entities/ReconcileMatch'
import { mapCreditCardItemApiModel } from './mapCreditCardItemApiModel'
import { mapStatementItemApiModel } from './mapStatementItemApiModel'
import { type ReconcileMatchApiModel } from '../api-models/ReconcileMatchApiModel'

export const mapReconcileMatchApiModel = (
  model: ReconcileMatchApiModel
): ReconcileMatchConstructor => ({
  id: model.id,
  status: model.status,
  amount: model.amount,
  creditcardItems: model.creditcard_items.map(mapCreditCardItemApiModel),
  statementItems: model.statement_items.map(mapStatementItemApiModel),
})
